/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationDeleteReserveArgs } from '../gql/graphql';
import { MutationHookOptions, useMutation } from '@apollo/client';
import { GET_RESERVES } from './reserves.query';
import { graphql } from '../gql';

export const DELETE_RESERVE = graphql(`
  mutation deleteReserve($reserveUuid: String!) {
    deleteReserve(reserveUuid: $reserveUuid) {
      result
    }
  }
`);

export function useDeleteReserveMutation(
  options: MutationHookOptions<any, MutationDeleteReserveArgs> = {}
) {
  const [deleteReserve, { loading, error, reset }] = useMutation(
    DELETE_RESERVE,
    {
      refetchQueries: [GET_RESERVES],
      ...options,
    }
  );

  return {
    deleteReserve,
    loading,
    error,
    reset,
  };
}
